import { IServiceEnablementResponse } from "@wingspanhq/benefits/dist/src/lib/interfaces";
import { benefitsService } from "./benefitsService";

export const getBenefitsService =
  async (): Promise<IServiceEnablementResponse> => {
    const { data } = await benefitsService.get("/service");
    return data;
  };
